// extracted by mini-css-extract-plugin
export default {"validationErrorMessage":"validationErrorMessage---VYusf","feedbackErrorIcon":"feedbackErrorIcon---Aki7L"};